// Design tokens for the V2 report.
//
// Every V2 page and chart pulls its colours from here, so changing a value in
// this file updates the whole report. Keep it in sync with the custom
// properties at the top of pages/css/report-v2.css, which hold the same values
// for the parts that are styled in CSS rather than drawn by a chart.
//
// The brand palette is three colours:
const brand = {
  navy: "#05233f",
  blue: "#1f6e9e",
  cyan: "#3dc5f1",
};

export const colors = {
  // Current year / "your organization" series.
  primary: brand.cyan,
  // Previous year / "Employer Partner avg." series.
  secondary: brand.navy,
  // Third series used on the per-step charts, where the current year, the
  // previous year and the benchmark are shown side by side.
  tertiary: brand.blue,
  // Threshold marker drawn across the result charts. Deliberately outside the
  // brand palette so it reads as a separate reference line rather than a
  // fourth data series.
  threshold: "#E4003A",
  // Remainder of a donut ring.
  track: "#E3E6EA",

  text: brand.navy,
  textMuted: "#5A6B7B",
  heading: brand.navy,
  // Text on the dark gradient slides.
  textOnDark: "#FFFFFF",
  textOnDarkMuted: "rgba(255, 255, 255, 0.85)",

  // Pale hexagon watermark on light pages.
  hexLight: "#F2F6FA",
  cardBorder: "#DCE3EA",

  // Dark gradient used by the divider slides and the cards.
  gradientDarkFrom: brand.navy,
  gradientDarkTo: brand.blue,
};

export const gradients = {
  dark: `linear-gradient(120deg, ${colors.gradientDarkFrom} 0%, ${colors.gradientDarkTo} 100%)`,
  card: `linear-gradient(115deg, ${colors.gradientDarkFrom} 0%, ${colors.gradientDarkTo} 100%)`,
};

// Artwork supplied by the design team, in public/assets/images/report/v2.
// Replacing a file is enough to update the report - no code change needed.
const base = "/assets/images/report/v2";

export const images = {
  // Full-bleed dark gradient with hexagons - cover and the divider slides.
  cover: `${base}/cover.png`,
  dividerDark: `${base}/divider-dark.png`,
  // Pale hexagon watermarks.
  hexLight: `${base}/bg-hex-light.png`,
  hexLeft: `${base}/bg-hex-left.png`,
  // Slide-specific backgrounds.
  bgConfirmation: `${base}/bg-confirmation.png`,
  bgDevelopment: `${base}/bg-development.png`,
  // Dark gradient with no hexagon pattern - SELECTIO services.
  bgNoHex: `${base}/bg-nohex.png`,
  bgTimeline: `${base}/bg-timeline.png`,
  bgButton: `${base}/bg-button.png`,
  // Single hexagons used as decorative frames.
  hexWhite: `${base}/hex-white.svg`,
  hexBlue: `${base}/hex-blue.svg`,
  // Logos.
  logoSelectioWhite: `${base}/selectio-white.png`,
  logoSelectioColour: `${base}/selectio-colour.svg`,
  logoEpWhite: `${base}/employer-partner-white.svg`,
  logoEpColour: `${base}/employer-partner-colour.svg`,
  logoEpMark: `${base}/employer-partner-mark.svg`,
  partnerAlmaCareer: `${base}/partner-alma-career.svg`,
  partnerMojPosao: `${base}/partner-moj-posao.svg`,
  // The two Employee Life Cycle diagrams on the "two perspectives" slide.
  elcEmployee: `${base}/elc-employee.png`,
  elcBusiness: `${base}/elc-business.png`,
};

// The threshold drawn on the key topic charts (grade scale 0-3).
export const GRADE_THRESHOLD = 2;
// The overall score required to pass, in percent.
export const RESULT_THRESHOLD = 75;
